import AtsTddsDashboardPage from './AtsTddsDashboardPage';
export { AtsTddsDashboardPage };
export default AtsTddsDashboardPage;
